import { Controller } from "@hotwired/stimulus"

// A click target that expands/collapses a content region with a smooth height
// animation, plus a chevron that rotates to reflect the open state.
//
// The animation uses the grid-template-rows 0fr -> 1fr trick: the content
// target is a grid whose single row animates between 0fr (collapsed) and 1fr
// (full content height), so it works without knowing the content's height.
// The content's immediate child must have overflow-hidden so it clips while
// collapsed (see the markup in api_webhooks/_form).
//
// For assistive tech, put a "button" target on the toggle control (with
// aria-controls pointing at the content region); its aria-expanded is kept in
// sync with the open state.
export default class extends Controller {
  static targets = ["button", "content", "chevron"]
  static values = { open: { type: Boolean, default: false } }

  toggle() {
    this.openValue = !this.openValue
  }

  openValueChanged() {
    this.contentTarget.classList.toggle("grid-rows-[1fr]", this.openValue)
    this.contentTarget.classList.toggle("grid-rows-[0fr]", !this.openValue)
    if (this.hasChevronTarget) {
      this.chevronTarget.classList.toggle("rotate-180", this.openValue)
    }
    if (this.hasButtonTarget) {
      this.buttonTarget.setAttribute("aria-expanded", this.openValue)
    }
  }
}
